export const GPU_CHART_HEIGHTS = {
  SINGLE: 240,
  DOUBLE: 180,
  TRIPLE: 150,
  DEFAULT: 120,
  LINE_CHART: 320,
} as const;

export const GPU_CHART_WIDTHS = {
  FULL: '100%',
  SELECT: 200,
} as const;
